module.exports = __webpack_public_path__ + "img/zain_ramadan_tvc_2020-1.c79dbd6d.png";